const DATE_LOCALE = "en-GB";

const dateFormatter = new Intl.DateTimeFormat(DATE_LOCALE, {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

const timeFormatter = new Intl.DateTimeFormat(DATE_LOCALE, {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

export function formatAppDate(value, fallback = "—") {
  if (!value) return fallback;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;

  return dateFormatter.format(date);
}

export function formatAppTime(value, fallback = "—") {
  if (!value) return fallback;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;

  return timeFormatter.format(date);
}

export function formatAppDateTime(value, fallback = "—") {
  if (!value) return fallback;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;

  return `${formatAppDate(date, fallback)} ${formatAppTime(date, fallback)}`;
}
